import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { CartState, UtmParams } from '../api/types';

const useCartStore = create<CartState>()(
  persist(
    (set) => ({
      productId: null,
      priceId: null,
      coupon: null,
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
      utmTerm: null,
      utmContent: null,
      sessionId: null,

      setProduct: (productId: string, priceId: string) => {
        set({ productId, priceId });
      },

      setCoupon: (coupon: string | null) => {
        set({ coupon });
      },

      setUtmParams: (params: UtmParams) => {
        set({
          utmSource: params.utm_source || null,
          utmMedium: params.utm_medium || null,
          utmCampaign: params.utm_campaign || null,
          utmTerm: params.utm_term || null,
          utmContent: params.utm_content || null,
        });
      },

      setSessionId: (sessionId: string | null) => {
        set({ sessionId });
      },

      clearCart: () => {
        set({
          productId: null,
          priceId: null,
          coupon: null,
          utmSource: null,
          utmMedium: null,
          utmCampaign: null,
          utmTerm: null,
          utmContent: null,
          sessionId: null,
        });
      },
    }),
    {
      name: 'cart-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        productId: state.productId,
        priceId: state.priceId,
        coupon: state.coupon,
        utmSource: state.utmSource,
        utmMedium: state.utmMedium,
        utmCampaign: state.utmCampaign,
        utmTerm: state.utmTerm,
        utmContent: state.utmContent,
        sessionId: state.sessionId,
      }),
    }
  )
);

export default useCartStore;
